import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/components/Footer.scss';

const Footer = () => {
    return (
        <footer className="footer">
            <div className="footer-container">
                <div className="footer-top">
                    <div className="footer-logo">
                        <img src="/assets/images/owl-logo.png" alt="Black owLs Logo" />
                        <h3>Black owLs <span className="gold-text">Hoşgeldiniz</span></h3>
                    </div>

                    <div className="footer-links">
                        <div className="links-column">
                            <h4>Hızlı Bağlantılar</h4>
                            <ul>
                                <li><a href="/#hero-home">Hakkımızda</a></li>
                                <li><a href="/#timeline">Başarılarımız</a></li>
                                {/* <li><a href="/#join">Takıma Katıl</a></li> */}
                                <li><a href="/#team">Takım Üyeleri</a></li>
                            </ul>
                        </div>

                        <div className="links-column">
                            <h4>Başvurular</h4>
                            <ul>
                                <li><Link to="/takimbasvuru">Takım Başvurusu</Link></li>
                                <li><Link to="/takimbasvuru">Topluluk Başvurusu</Link></li>
                                <li><Link to="/takimbasvuru">Kafes Başvurusu</Link></li>
                            </ul>
                        </div>

                        <div className="links-column">
                            <h4>Sosyal Medya</h4>
                            <ul>
                                <li><a href="https://www.instagram.com/blackowlsofc/" target="_blank" rel="noopener noreferrer">Instagram</a></li>
                                <li><a href="https://www.tiktok.com/@blackowlsofc" target="_blank" rel="noopener noreferrer">Tiktok</a></li>
                                <li><a href="http://discord.blackowls.net" target="_blank" rel="noopener noreferrer">Discord</a></li>
                                <li><a href="https://www.youtube.com/@blackowls" target="_blank" rel="noopener noreferrer">Youtube</a></li>
                            </ul>
                        </div>
                    </div>
                </div>

                <div className="footer-bottom">
                    <p>
                        &copy; {new Date().getFullYear()} Black owLs Squad Türkiye. Tüm hakları saklıdır.
                    </p>
                    <p>
                        <Link to="/gizlilik-politikasi" className="mr-4">Gizlilik Politikası</Link>
                        <Link to="/kullanim-kosullari" className="mr-4">Kullanım Koşulları</Link>
                        <Link to="/kvkk-kosullari">KVKK Koşulları</Link>
                    </p>
                </div>
            </div>
        </footer>
    );
};

export default Footer;